module.exports = __webpack_public_path__ + "static/media/rbcx-poster.274039f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rbcx/rbcx-poster.png
// module id = 11
// module chunks = 0